/**
 * Generated bundle index. Do not edit.
 */

export {NgxSlackModule} from './index';

export {FeedbackComponent as ɵb} from './src/component/feedback.component';
export {SlackUrlToken as ɵa} from './src/module';
export {FeedbackService as ɵc} from './src/service/feedback.service';